export default {
  tip_client_label: 'Tip client',
  tip_client_casnic: 'casnic',
  tip_client_casnic_hint: '',
  tip_client_non_casnic: 'noncasnic',
  tip_client_non_casnic_hint: 'Client noncasnic cu un număr mediu scriptic de salariați mai mic de 50 si o cifra de afaceri anuala sau o valoare totala a activelor din bilanțul contabil, conform raportărilor fiscale anuale, care nu depășește 10 milioane euro',
  tip_client_non_casnic_fara: 'noncasnic - particularizat',
  tip_client_non_casnic_fara_hint: 'Client noncasnic care nu îndeplinește condiția de a avea un număr mediu scriptic de salariați mai mic de 50 si o cifra de afaceri anuala sau o valoare totala a activelor din bilanțul contabil, conform raportărilor fiscale anuale, care nu depășește 10 milioane euro',
  tip_client_rule_required: 'Tipul de client este obligatoriu.',
  tip_client_rule_in: 'Tipul de client este invalid.',

  tip_oferta_label: 'Tip oferta',
  tip_oferta_oricare: 'Oricare',
  tip_oferta_concurentiala: 'Oferte concurentiale',
  tip_oferta_serviciu_universal: 'Oferte serviciu universal',
  tip_oferta_rule_required: 'Tipul ofertei este obligatoriu.',
  tip_oferta_rule_in: 'Tipul ofertei este invalid.',

  tip_produs_label: 'Tip produs',
  tip_produs_oricare: 'Oricare',
  tip_produs_fix: 'Pret fix pe intreaga perioada contractuala',
  tip_produs_variabil: 'Pret variabil',
  tip_produs_rule_required: 'Tipul produsului este obligatoriu.',
  tip_produs_rule_in: 'Tipul produsului este invalid.',

  valoare_fixa_label: 'Oferte care includ componentă fixa',
  valoare_fixa_oricare: 'Oricare',
  valoare_fixa_da: 'da',
  valoare_fixa_nu: 'nu',
  valoare_fixa_rule_in: '',

  valoare_factura_curenta_label: 'Valoarea facturii curente pentru comparatie (lei)',
  valoare_factura_curenta_required: 'Valoarea facturii curente pentru comparatie (lei) este obligatoriu.',

  consum_lunar_label: 'Consum lunar',
  consum_lunar_rule_required: 'Consumul lunar este obligatoriu.',
  consum_lunar_rule_number: 'Consumul lunar trebuie sa fie un numar intreg pozitiv.',

  judet_label: 'Judet',
  judet_rule_required: 'Judetul este obligatoriu.',

  data_start_aplicare_label: 'Data de la care se aplica oferta',
  data_start_aplicare_rule_required: 'Data de la care se aplica oferta este obligatoriu.',

  nivel_tensiune_label: 'Nivel tensiune',
  nivel_tensiune_inalt: 'Inalta tensiune',
  nivel_tensiune_mediu: 'Medie tensiune',
  nivel_tensiune_jos: 'Joasa tensiune',
  nivel_tensiune_rule_required: 'Nivelul de tensiune este obligatoriu.',
  nivel_tensiune_rule_in: 'Nivelul de tensiune este invalid.',

  perioada_contract_label: 'Perioada contract',
  perioada_contract_oricare: 'Oricare',
  perioada_contract_sub_1_an: 'mai mica de 1 an',
  perioada_contract_1_an: '1 an',
  perioada_contract_intre_1_an_si_2_ani: 'intre 1 si 2 ani',
  perioada_contract_2_ani: '2 ani',
  perioada_contract_intre_2_ani_si_3_ani: 'intre 2 ani si 3 ani',
  perioada_contract_3_ani: '3 ani',
  perioada_contract_mai_mare_de_3_ani: 'mai mare de 3 ani',
  perioada_contract_nedeterminata: 'nedeterminata',
  perioada_contract_rule_required: 'Perioada contractuala este obligatorie.',
  perioada_contract_rule_in: 'Perioada contractuala este invalida.',

  tip_pret_oferta_label: 'Tip pret',
  tip_pret_oferta_nediferentiat: 'Nediferentiat',
  tip_pret_oferta_diferentiat: 'Diferentiat pe zone orare',
  tip_pret_oferta_rule_required: 'Tipul de pret este obligatorie.',
  tip_pret_oferta_rule_in: 'Tipul de pret este invalid.',

  factura_electronica_label: 'Mod transmitere factura',
  factura_electronica_oricare: 'Oricare',
  factura_electronica_posta: 'Posta / Curier',
  factura_electronica_email: 'E-mail',
  factura_electronica_portal: 'Portal',
  factura_electronica_posta_si_email: 'Posta/curier si electronic',
  factura_electronica_rule_required: 'Factura electronica este obligatorie.',
  factura_electronica_rule_in: 'Factura electronica este invalida.',

  pret_oferta_diferentiat_label: '',
  pret_oferta_diferentiat_zi_rule_required: 'Procentul de consum zona de zi este obligatoriu.',
  pret_oferta_diferentiat_zi_rule_number: 'Procentul de consum zona de zi trebuie sa fie un numar intreg pozitiv.',
  pret_oferta_diferentiat_zi_rule_between: 'Procentul de consum zona de zi trebuie sa fie un numar intre 0 si 100.',

  frecventa_emitere_factura_label: 'Frecventa emitere factura',
  frecventa_emitere_factura_oricare: 'Oricare',
  frecventa_emitere_factura_lunar: 'lunar',
  frecventa_emitere_factura_2_luni: 'la 2 luni',
  frecventa_emitere_factura_3_luni: 'la 3 luni',
  frecventa_emitere_factura_altele: 'altele',
  frecventa_emitere_factura_rule_in: 'Frecventa de emitere a facturii este invalida.',

  frecventa_citire_contor_label: 'Frecventa citire contor',
  frecventa_citire_contor_oricare: 'Oricare',
  frecventa_citire_contor_lunar: 'lunar',
  frecventa_citire_contor_2_luni: 'la 2 luni',
  frecventa_citire_contor_3_luni: 'la 3 luni',
  frecventa_citire_contor_4_luni: 'la 4 luni',
  frecventa_citire_contor_5_luni: 'la 5 luni',
  frecventa_citire_contor_6_luni: 'la 6 luni',
  frecventa_citire_contor_rule_in: 'Frecventa de citire a contorului este invalida.',

  energie_sursa_regenerabile_label: 'Energie din surse regenerabile',
  energie_sursa_regenerabile_oricare: 'Oricare',
  energie_sursa_regenerabile_da: 'da',
  energie_sursa_regenerabile_nu: 'nu',
  energie_sursa_regenerabile_rule_in: '',

  compara_preturi_label: 'Compara preturi',

  documente_client_nou_label: 'Client nou (construcţie nouă, schimbare proprietar,etc.)',
  documente_client_furnizor_existent: 'Schimbare condiţii contract (schimbare tip contract, ofertă noua, prelungire contract, etc)',
  documente_client_furnizor_nou: 'Schimbare furnizor',

  completati_factura_curenta: '(completati valoare factura curenta)',
}
